import { InputAdornment, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import React from 'react';

type PropsType = TextFieldProps & {
  currency: string;
};

export const CurrencyField = (props: PropsType) => {
  const { slotProps, currency, value, ...restProps } = props;

  const fieldProps: TextFieldProps = {
    slotProps: {
      ...slotProps,
      input: {
        inputMode: 'decimal',
        inputProps: {
          style: {
            textAlign: 'right',
          },
        },
        endAdornment: (
          <InputAdornment position="end">{currency}</InputAdornment>
        ),
        ...slotProps?.input,
      },
    },
    value: typeof value === 'number' ? value.toFixed(2) : value,
    ...restProps,
  };

  return <TextField {...fieldProps} />;
};
